import { getMatchEvents } from '../services/football/matchEvents';
import { ITimelineApi } from '../types';

export const timeline = (): ITimelineApi => {
  return {
    getTimeline: (params, sdkOptions) => getMatchEvents({ params, sdkOptions }),
  };
};
